import React from 'react';
import { startStreaming } from '../../../dualChannel/audioApiWrapper/audioApiWrapper';
import { JsAudioDevice } from '../../../dualChannel/dualChannelTypes';

export default function useDualChannelAudioStream(device: JsAudioDevice | undefined, enabled: boolean): MediaStream | null {
  const [stream, setStream] = React.useState<MediaStream | null>(null);

  React.useEffect(() => {
    if (!enabled || !device) {
      setStream(null);
      return undefined;
    }

    let cancelled = false;
    let acquiredStream: MediaStream | null = null;

    startStreaming(device)
      .then((nextStream) => {
        if (!cancelled) {
          acquiredStream = nextStream;
          setStream(nextStream);
        } else {
          nextStream.getTracks().forEach((track) => track.stop());
        }
      })
      .catch((err) => {
        if (!cancelled) {
          console.error('Failed to start dual-channel audio stream', err);
          setStream(null);
        }
      });

    return () => {
      cancelled = true;
      acquiredStream?.getTracks().forEach((track) => track.stop());
      setStream(null);
    };
  }, [device, enabled]);

  return stream;
}
